import React from 'react';
import {
  Outlet,
} from 'react-router-dom';
import useUserInfo from 'pages/Dashboard/hooks/useUserInfo';
import isNil from 'lodash/isNil';
import Navigation from 'pages/Dashboard/pages/Fax/Navigation';

export default function Fax() {
  const userInfo = useUserInfo();
  const isEnabled = !isNil(userInfo?.organization?.eFaxConfig);

  return (
    isEnabled
      ? (
        <div className="h-full w-full">
          <div className="h-full w-full max-h-[calc(100vh-1.5rem)] overflow-y-hidden">
            <div className="flex flex-col w-full h-full">
              <Navigation />
              <div className="flex-1 w-full pt-4 overflow-y-hidden">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      )
      : (
        <div className="flex-1 flex flex-col w-full items-center justify-center">
          <div className="text-lg">Fax is not setup for this organization.</div>
        </div>
      )
  );
}
